var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { TemplateLabel, Icon } from "../../Layout";
import { Loader } from "../../components/Elements/Loader";

export class SearchResults extends Component {
  render() {
    const loading = /*#__PURE__*/
    _jsx("div", { className: "cs-loader-container" }, void 0, "\xA0", /*#__PURE__*/

    _jsx(Loader, {})
    );

    const results = this.props.results.toJS().map((result, index) => /*#__PURE__*/
    _jsx("div", {
      className: `item ${this.props.selected === result.sharedId ? 'is-selected' : ''}`,

      onClick: () => this.props.onClick(result.sharedId, result) }, index, /*#__PURE__*/

    _jsx("div", { className: "item-info" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "item-name" }, void 0, /*#__PURE__*/
    _jsx(Icon, { className: "item-icon item-icon-center", data: result.icon }),
    result.title
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "item-actions" }, void 0, /*#__PURE__*/
    _jsx(TemplateLabel, { template: result.template })
    )
    )
    );

    return /*#__PURE__*/(
      _jsx("div", {}, void 0,
      this.props.searching ? loading : '', /*#__PURE__*/
      _jsx("div", { className: "item-group" }, void 0, results)
      ));

  }
}








export default SearchResults;